export enum PostType {
	BUILDER = 'builder',
}
